import React, { useState } from 'react';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { firestore } from '../firebase';

export default function ContactUs() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [feedback, setFeedback] = useState(null); // { type: 'success' | 'error', text: string }

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (submitting) return;
    setFeedback(null);
    setSubmitting(true);
    try {
      // Basic validation
      const trimmedName = name.trim();
      const trimmedEmail = email.trim();
      const trimmedMessage = message.trim();
      if (!trimmedName || !trimmedEmail || !trimmedMessage) {
        throw new Error('Please fill out all fields.');
      }

      await addDoc(collection(firestore, 'contact_messages'), {
        name: trimmedName,
        email: trimmedEmail,
        message: trimmedMessage,
        status: 'pending',
        createdAt: serverTimestamp(),
      });

      setFeedback({ type: 'success', text: 'Thanks! Your message has been sent. We will get back to you shortly.' });
      setName('');
      setEmail('');
      setMessage('');
    } catch (err) {
      setFeedback({ type: 'error', text: err?.message || 'Something went wrong. Please try again.' });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="contact-page" style={{
      maxWidth: '900px',
      margin: '20px auto',
      background: '#ffffff',
      borderRadius: '12px',
      padding: '24px',
      boxShadow: '0 2px 12px rgba(0,0,0,0.08)'
    }}>
      <h1 style={{ marginTop: 0 }}>Contact Us</h1>

      <p>
        We'd love to hear from you. Reach us using the details below or email us and we will get back to you.
      </p>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 24 }}>
        <div>
          <h3>Company</h3>
          <p style={{ margin: 0 }}><strong>SHOPIE TECHNOLOGIES PVT. LTD.</strong></p>
          <h3 style={{ marginTop: 16 }}>Address</h3>
          <p style={{ margin: 0 }}>
            A 19, Ground Floor FIEE Complex,<br/>
            Okhla Phase II, Okhla Industrial Estate,<br/>
            New Delhi, India - 110020
          </p>

          <h3 style={{ marginTop: 16 }}>Phone</h3>
          <p style={{ margin: 0 }}>
            <a href="tel:+911169266020">+91 1169266020</a>
          </p>

          <h3 style={{ marginTop: 16 }}>Email</h3>
          <p style={{ margin: 0 }}>
            <a href="mailto:support@shopiebazar.com">support@shopiebazar.com</a>
          </p>
        </div>

        <div>
          <h3>Send us a message</h3>
          {feedback && (
            <div style={{
              marginBottom: 12,
              padding: '10px 12px',
              borderRadius: 8,
              background: feedback.type === 'success' ? '#e6ffed' : '#ffe6e6',
              color: feedback.type === 'success' ? '#0a7f3f' : '#c02626',
              border: `1px solid ${feedback.type === 'success' ? '#a7f3d0' : '#fecaca'}`,
            }}>
              {feedback.text}
            </div>
          )}
          <form onSubmit={handleSubmit}>
            <div style={{ display: 'grid', gap: 12 }}>
              <input
                type="text"
                placeholder="Your name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
                style={{ padding: 12, borderRadius: 8, border: '1px solid #e5e7eb' }}
              />
              <input
                type="email"
                placeholder="Your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                style={{ padding: 12, borderRadius: 8, border: '1px solid #e5e7eb' }}
              />
              <textarea
                placeholder="Your message"
                rows={5}
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                required
                style={{ padding: 12, borderRadius: 8, border: '1px solid #e5e7eb', resize: 'vertical' }}
              />
              <button type="submit" disabled={submitting} style={{
                padding: '12px 16px',
                borderRadius: 8,
                border: 'none',
                background: submitting ? '#7c4dff' : '#651fff',
                opacity: submitting ? 0.85 : 1,
                color: '#fff',
                fontWeight: 600,
                cursor: submitting ? 'not-allowed' : 'pointer'
              }}>{submitting ? 'Sending…' : 'Send'}</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
